var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "570pt",
    height: "69pt",
    viewBox: "0 0 570 69",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 69) scale(.1 -.1)",
    fill: "#a02b1c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1210 370v-240h45 45v135c0 90 4 135 11 135 8 0 164-127 342-278 16-14 17-3 17 226v242h-50-50v-130c0-102-3-130-13-130-8 0-89 63-180 140l-167 140v-240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3381 375c-73-129-139-235-146-235-13 0-145 143-145 158 0 6 13 13 30 17 89 19 119 161 50 238l-28 32-392 6v-45-46h164c90 0 171-3 180-6 22-8 22-80 0-88-9-3-90-6-180-6h-164v-135-135h45 45v90 90h54 55l82-90 83-90h116 116l79 140c44 77 85 140 92 140 6 0 46-63 90-140l78-140h53c29 0 51 3 49 8-3 4-62 108-132 232-71 124-131 228-134 232s-66-98-140-227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5433 565c0-22 2-30 4-17 2 12 2 30 0 40-3 9-5-1-4-23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5507 576c10-13 19-23 21-21 5 5-22 45-31 45-4 0 0-11 10-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5557 568c8-46 13-48 13-5 0 21-4 37-10 37-5 0-7-14-3-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257 353c74-131 137-239 138-241 1-1 55 91 121 205 65 115 126 223 137 241l19 32h-54-53l-78-140c-44-77-84-140-90-140-7 0-48 63-92 140l-79 140h-52-53l136-237z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m700 545v-45h230 230v45 45h-230-230v-45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1720 546v-45l166-3c202-4 194 2 194-138 0-135 1-134-149-138l-121-4v96 96h-45-45v-141-140l179 3c163 3 182 5 207 24 63 47 69 64 69 204s-6 157-69 204c-25 19-44 21-207 24l-179 3v-45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2322 573c-18-9-43-30-55-47-20-28-22-43-22-166 0-124 2-138 22-166 40-56 71-64 262-64h171v45 45h-159c-209 0-206-2-206 140s-3 140 206 140h159v45 45h-172c-139 0-179-4-206-17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3820 545v-45h230 230v45 45h-230-230v-45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4330 545v-45h90 90v-185-185h50 50v185 185h90 90v45 45h-230-230v-45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4850 545v-45h130c110 0 130-2 130-15 0-9-63-92-140-185l-141-170h241 240v45 45h-135c-101 0-135 3-135 13 0 6 63 88 140 181 77 92 140 170 140 172s-106 4-235 4h-235v-45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m700 265v-135h230 230v45 45h-185-185v45 45h185 185v45 45h-230-230v-135z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3820 265v-135h45 45v90 90h185 185v45 45h-230-230v-135z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.fa3fe5f99fa49fce7e346daca68c1c23.svg";
export { ForwardRef as ReactComponent };